import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PRODUCTLIST, GETADDRESS } from 'src/app/config';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-filter-product',
    templateUrl: './filter-product.component.html',
    styleUrls: ['./filter-product.component.css'],
    
})
export class FilterProductComponent implements OnInit {
  subid: any;
   url :any;
  data:any;
  products:any;
  wish:any;
  jewelery_for:any;
  material:any;
  purity:any;
  price:any;
  jewelery_type:any;
  filter:any;
  div:boolean=false;
  alert:boolean=false;
  loader:boolean;
  pager:boolean;
  message:string="NO PRODUCT AVAILABLE";
  f:any;
  drop:any;
  pages: any;
  current_page=1;
  page=1;
  priceWeight:any;
  state: any;
  addresses: any;
  igst: boolean;
 // @ViewChild('addclosebutton') addclosebutton;
//@ViewChild('deleteclosebutton') deleteclosebutton;
  constructor(private api: ApiService, private route: ActivatedRoute,private router:Router,public http: HttpClient) {
    // this.api.Get(GETADDRESS).then(data => {
    //   this.addresses = data['data'];
    //   this.addresses = this.addresses[0];
    //   console.log(this.addresses);
    //   this.state = this.Getgst(this.addresses.pincode);
    //   setTimeout(() => {
    //     this.state = this.state.__zone_symbol__value.data[0].state_name;
    //     console.log(this.state);
    //       },1000);
     

      this.drop=this.api.drop; 
    this.route.params.subscribe(params => {
      this.subid = params.id;
      this.route.queryParamMap.subscribe(params =>{
        let a =  params.get('page');
        this.current_page = Number(a);
        this.page = this.current_page;
        // this.getProduct(this.subid,this.current_page);
        this.searchProduct(this.subid,this.current_page);
      });
      });


    // }).catch(d=>{
    //   this.igst = true;
    //   this.drop=this.api.drop; 
    // this.route.params.subscribe(params => {
    //   this.subid = params.id;
    //   this.route.queryParamMap.subscribe(params =>{
    //     let a =  params.get('page');
    //     this.current_page = Number(a);
    //     this.page = this.current_page;
    //     this.getProduct(this.subid,this.current_page);
    //   });
    //   });
      
//});   
  }
  
  pagechanged(){
    this.router.navigate(['filter',this.subid], { queryParams: { page: this.page}});
  }
  public Getgst(pincode) {
    return new Promise((resolve, reject) => {
      this.http.get('https://pincode.saratchandra.in/api/pincode/'+pincode)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }
 
  temporaryfunction()
  {
    this.loader=true;
    this.pager=false;
    this.api.Get(PRODUCTLIST+"?subsubcategory_id="+this.subid).then(data=>{
      this.pager=true;
      this.loader=false;
      this.div=true;
      this.alert=false
      this.products = data['data'];
     // console.log(this.products);
      this.url = data['url'] + '/';
    }).catch(d=>{
      this.pager=true;
      this.loader=false;
      this.div=false;
       this.alert=true;
      console.log(d);
    });
  }
  getProduct(value,page=1)
  {
    this.loader=true;
    this.pager=false;
    this.f=this.api.getfilter();
    //{subsubcategory_id: value } 
    this.api.Post2(PRODUCTLIST,JSON.stringify(this.f),{'subsubcategory_id':value,'page':page}).then(data  => {
      this.pager=true;
      this.loader=false;
      this.div=true;
      this.alert=false
      this.products = data['data'];
      this.priceWeight = this.api.calculateFilter(this.products,data['price'],this.api.igst);
      console.log("LIST PRODUCT PRICE WEIGHT",this.priceWeight);
      this.pages = Math.ceil(data['pagination']/32)
      this.url = data['url'] + '/';
       }).catch(d=>{

        this.api.Post2(PRODUCTLIST+"?subsubcategory_id="+value,{},{'subsubcategory_id':value,'page':page}).then(data  => {
          this.pager=true;
          this.loader=false;
          this.div=true;
          this.alert=false
          this.products = data['data'];
         // console.log(this.products);
          this.url = data['url'] + '/';
           })



        this.pager=true;
        this.loader=false;
      this.temporaryfunction();
         this.div=false;
         this.alert=true;
        console.log(d);
      });
  }
  go(value) {
    this.api.godetail(value);
  }
  checkCart(pid)
  {
      let check=this.api.checkCart(pid);
     // console.log(check);
      return check;
 }
 qtyUpdate(pid,value)
 {
      this.api.qtyUpdate(pid,value);
 }
 quantity(pid)
 {
      let cart=this.api.getCart();
      if(cart)
    {
            let result=cart.find(x => x.product_id == pid);
            // console.log(result);
            if(result)
            { 
                  let cartId=result.cart_id;
                  let c=Number(result.count);
                  return c;
              } 
              else{
                return(0);
              }
      }
 }
 addToCart(s)
  {
    this.api.addToCart(s);
  }
  wishlist(pid) {
    // console.log("in wishlist");
     //console.log(pid);
     if(this.drop==0)
     {
       
      this.api.setGoto();
      this.api.onSuccess('Please Login First to Continue','Login');
      // document.getElementById("openModalButton").click();
     }
     else if(this.drop==1)
    {
      this.api.checkWishlist(pid);
    }
   }
   deleteWishlist(pid)
   {
       this.api.deleteWishlist(pid);
   }
   checkHeart(pid)
  {

    //console.log("checkheart");
    this.wish = this.api.getWishlist();
    if (this.wish) {
            let result = this.wish.find(x => x.product_id === pid);
        //  console.log("result="+result);
            if (result)
            { 
             // console.log("present");
              return true;
            
            }
            else
            {
              //console.log("not present");
              return false;
              
            } 
      }
      else{
        //console.log("not present");
        return false;
      }
  }
  ngOnInit() {
    this.loader=true;
    this.pager=false;
    this.api.getlogin.subscribe(data => {
      console.log(+data);
      this.drop=data;
      console.log(this.drop);    
     });

    this.f=this.api.getfilter();
    
   if(!this.f)
    {

      let initial={"menu":{"jewelery_for":[],"jewelery_type":[],"material":[],"price":{},"purity":[]}};
      this.api.setfilter(initial);
      // this.getProduct(this.subid);
    }

        this.api.filterChange.subscribe(data=>{
          console.log("filter changed");
             this.f=this.api.getfilter();
                      if(this.f)
                    {
                          // this.filterApi(JSON.stringify(this.f));
                          // this.getProduct(this.subid);
                          this.searchProduct(this.subid)
                    }
                    else if(!this.f)
                    {

                      let initial={"menu":{"jewelery_for":[],"jewelery_type":[],"material":[],"price":{},"purity":[]}};
                      this.api.setfilter(initial);
                      // this.getProduct(this.subid);
                      this.searchProduct(this.subid);
                    }
          })
  }
  
  searchProduct(subcid:any, page=1){
    this.loader=true;
    this.pager=false;
    this.f=this.api.getfilter();
    let obj = {
      gender: this.f?.menu?.jewelery_for,
      jewelery_type: this.f?.menu?.jewelery_type[0],
      purity: this.f?.menu?.purity,
      material: this.f?.menu?.material,
      price: this.f?.menu?.price,
      manufacture_id: "",
      subsubcategory_id: subcid,
      subcategory_id: "",
      orderby: "asc",
      search: "",
      page:page
    }
    this.api.Post2(PRODUCTLIST, obj).then(data  => {
      this.pager=true;
      this.loader=false;
      this.div=true;
      this.alert=false
      this.products = data['data'];
      this.priceWeight = this.api.calculateFilter(this.products,data['price'],this.api.igst);
      console.log("LIST PRODUCT PRICE WEIGHT",this.priceWeight);
      this.pages = Math.ceil(data['pagination']/32)
      this.url = data['url'] + '/';
    }).catch(d=>{
      this.pager=true;
      this.loader=false;
      this.temporaryfunction();
      this.div=false;
      this.alert=true;
      console.log(d);
    })
  }
}
